module.exports = __webpack_public_path__ + "static/img/disrun.2de3f2fb.jpg";